// @ts-expect-error: Intentional ignore
import { defineAbility } from '@casl/ability'

export default defineAbility(() => {
  // const authStore = useAuthStore()
  // const permissions = authStore.permissions
  // permissions.forEach((permission) => {
  //   can(permission.action, permission.subject)
  // })
})
